import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CameraApp from "@/components/CameraApp";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CameraApp />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        offset={140}
        toastOptions={{
          style: {
            background: "rgba(0,0,0,0.75)",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(20px)",
            fontFamily: "Work Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
